<template>
  <div class="ws-no-data-message">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
